import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { SectionType } from 'enums-lib';
import { AllowedSectionTypes } from '../../allowedSections/AllowedSectionTypes';

@Component({
  selector: 'app-docmerge-add-new-section',
  templateUrl: './docmerge-add-new-section.component.html',
  styleUrls: ['./docmerge-add-new-section.component.scss'],
  standalone: false,
})

export class DocmergeAddNewSectionComponent {
  @Input() validationErrors: ValidationErrors = undefined;
  @Input() allowedSectionTypes: AllowedSectionTypes;
  @Input() disabled = true;
  @Output() addSection = new EventEmitter<SectionType>();
  protected readonly SectionType = SectionType;
}
